import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError, BACKEND_URL } from "../../lib/api";

const lbl = "text-[11px] uppercase tracking-[0.16em] text-[var(--muted)]";
const pic = (u) => (u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

function TodayGrid({ couples, today }) {
  return (
    <div>
      <p className={`${lbl} mb-2`}>Showing today ({today})</p>
      <div className="grid sm:grid-cols-3 gap-3" data-testid="hero-today-couples">
        {couples.map((c, i) => (
          <div key={c.id} className="rounded-xl overflow-hidden border border-[var(--line)]" data-testid={`hero-today-${i}`}>
            <img src={pic(c.image_url)} alt="" className="w-full aspect-[16/9] object-cover" />
            <div className="p-3"><p className="font-medium text-sm">{c.headline}</p><p className="text-[11px] text-[var(--muted)]">{c.picked ? "Picked by you" : "Auto rotation"}</p></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function FeaturedCouplesAdmin() {
  const today = new Date().toISOString().slice(0, 10);
  const [d, setD] = useState(null);
  const [f, setF] = useState({ wedding_id: "", start_date: today, end_date: today });
  const load = () => api.get("/admin/hero-features").then((r) => {
    setD(r.data);
    setF((x) => (x.start_date === today && x.end_date === today ? { ...x, start_date: r.data.today, end_date: r.data.today } : x));
  }).catch((e) => toast.error(formatApiError(e)));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  async function add() {
    try { await api.post("/admin/hero-features", f); toast.success("Couple scheduled for the hero"); setF({ ...f, wedding_id: "" }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  }
  async function del(id) { try { await api.delete(`/admin/hero-features/${id}`); load(); } catch (e) { toast.error(formatApiError(e)); } }
  return (
    <div className="bg-white border border-[var(--line)] rounded-2xl p-5 space-y-5" data-testid="hero-featured-couples">
      <div>
        <h2 className="font-serif text-2xl">Featured couples in the hero</h2>
        <p className="text-sm text-[var(--muted)]">Each day 3 public weddings, real clients and showcase couples, are mixed in with your slides. Pick couples and dates below. Any spots you leave open rotate on their own every day.</p>
      </div>
      <TodayGrid couples={d.today_couples} today={d.today} />
      <div className="grid sm:grid-cols-[1fr_150px_150px_auto] gap-2 items-end">
        <label className="block"><span className={lbl}>Couple</span>
          <select value={f.wedding_id} onChange={(e) => setF({ ...f, wedding_id: e.target.value })} className="input-luxe mt-1" data-testid="hero-feature-wedding">
            <option value="">Choose a public wedding…</option>
            {d.eligible.map((w) => <option key={w.wedding_id} value={w.wedding_id}>{w.couple_names}{w.city ? ` · ${w.city}` : ""}{w.is_showcase ? " (showcase)" : ""}</option>)}
          </select>
        </label>
        <label className="block"><span className={lbl}>From</span><input type="date" value={f.start_date} onChange={(e) => setF({ ...f, start_date: e.target.value })} className="input-luxe mt-1" data-testid="hero-feature-start" /></label>
        <label className="block"><span className={lbl}>Until</span><input type="date" value={f.end_date} onChange={(e) => setF({ ...f, end_date: e.target.value })} className="input-luxe mt-1" data-testid="hero-feature-end" /></label>
        <button disabled={!f.wedding_id} onClick={add} className="btn-gold text-xs !py-2.5" data-testid="hero-feature-add"><Plus className="w-3.5 h-3.5" /> Schedule</button>
      </div>
      <div className="space-y-2" data-testid="hero-feature-list">
        {d.features.map((x) => (
          <div key={x.feature_id} className="flex items-center justify-between text-sm border-b border-[var(--line)]/60 pb-2" data-testid={`hero-feature-${x.feature_id}`}>
            <span><b className="font-medium">{x.couple_names}</b> <span className="text-[var(--muted)]">· {x.start_date} to {x.end_date}</span></span>
            <button onClick={() => del(x.feature_id)} className="p-2 rounded-full hover:bg-red-50 text-red-600" data-testid={`hero-feature-del-${x.feature_id}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
        {!d.features.length && <p className="text-sm text-[var(--muted)]">Nothing scheduled, so the hero picks 3 couples on its own each day.</p>}
      </div>
    </div>
  );
}
